import type { ReactNode } from 'react';
import { hasPermission, type Permission } from '../../../api/src/auth/permissions';
import { useWorkspace } from '../workspace-context';

export function useCanEdit(...permissions: Permission[]): boolean {
  return hasPermission(useWorkspace().user, ...permissions);
}
export function EditorOnly({
  children,
  permissions,
  any = false,
}: {
  children: ReactNode;
  permissions: Permission | readonly Permission[];
  any?: boolean;
}) {
  const user = useWorkspace().user;
  const keys = typeof permissions === 'string' ? [permissions] : permissions;
  return (any ? keys.some((key) => hasPermission(user, key)) : hasPermission(user, ...keys))
    ? children
    : null;
}
